module.exports = __webpack_public_path__ + "img/development-during-recession-top.650a1e13.jpeg";